import { createContext, useContext, useState, ReactNode } from "react";

export interface SelectedPlanData {
  name: string;
  setupPrice: number;
  maintenancePrice: number;
  trainingPrice: number | null;
  features: string[];
  maintenanceNote?: string;
  trainingNote?: string;
  discountAmount?: number;
  couponCode?: string;
  finalPrice?: number;
}

interface OrderContextType {
  selectedPlanData: SelectedPlanData | null;
  setSelectedPlanData: (data: SelectedPlanData | null) => void;
  clearSelectedPlan: () => void;
}

const OrderContext = createContext<OrderContextType | undefined>(undefined);

export function OrderProvider({ children }: { children: ReactNode }) {
  const [selectedPlanData, setSelectedPlanData] = useState<SelectedPlanData | null>(null);

  const clearSelectedPlan = () => {
    setSelectedPlanData(null);
  };

  return (
    <OrderContext.Provider value={{ selectedPlanData, setSelectedPlanData, clearSelectedPlan }}>
      {children}
    </OrderContext.Provider>
  );
}

export function useOrderContext() {
  const context = useContext(OrderContext);
  if (context === undefined) {
    throw new Error("useOrderContext must be used within an OrderProvider");
  }
  return context;
}
